import { firebase, firestore } from '../utilities/firebase'
import { errorOfType, errorTypes } from '../utilities/Errors'
import getCurrentUid from '../utilities/getCurrentUid'

const setKitOwn = async ({ own, kit }) => {
	try {
		const { kitId } = kit
		const uid = getCurrentUid()
		const ref = firestore.collection('kits').doc(kitId).collection('owners').doc(uid)
		if (own) {
			await ref.set({ uid, kitId, createdTimestamp: firebase.firestore.FieldValue.serverTimestamp() })
		} else {
			await ref.delete()
		}
	} catch (exception) {
		throw errorOfType(errorTypes.UNKNOWNERROR, exception)
	}
}

export default setKitOwn



// WEBPACK FOOTER //
// ./src/dataservices/setKitOwn.js